import React from 'react';

import { Box, Divider, Grid, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { DisplayFilters } from 'src/utils/filters/display-filters';
import ScrollableOneClickFilterPanel from '../../Filters/ScrollableOneClickFilterPanel';
import MealTypeFilter from '../../Filters/MealTypeFilter';
import IngredientFilter from 'src/components/Filters/IngredientFilter';
import NutritionFactsFilter from 'src/components/Filters/NutritionFactsFilter';
import ShelfLifeFilter from 'src/components/Filters/ShelfLifeFilter';
import ChefFilter from 'src/components/Filters/ChefFilter';
import SourcingStandardFilter from 'src/components/Filters/SourcingStandardFilter';
import TopRatedFilter from '../../Filters/TopRatedFilter';
import PrimaryProteinFilter from '../../Filters/PrimaryProteinFilter';

interface Props {
  displayFilters: DisplayFilters;
  selectedFilters: DisplayFilters;
  setSelectedFilters: React.Dispatch<React.SetStateAction<DisplayFilters>>;
}

const FilterPanel: React.FC<Props> = ({
  displayFilters,
  selectedFilters,
  setSelectedFilters,
}) => {
  const isSmallScreen = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('md'),
  );

  const tenantHasDietaryTemplateTagsToDisplay =
    !!displayFilters.tagCategories?.find(
      (category) => category.logicalId === 'DIETARY_TEMPLATE',
    )?.tags?.length;

  const topRatedByUserCategory = displayFilters.tagCategories?.find(
    (tc) => tc.logicalId === 'TOP_RATED_BY_USER',
  );

  return (
    <Grid
      container
      sx={{
        overflow: 'hidden',
        marginTop: isSmallScreen ? '1rem' : '1.3125rem',
        padding: isSmallScreen ? '0 0.35rem' : 0,
        width: '100%',
      }}
    >
      {tenantHasDietaryTemplateTagsToDisplay && (
        <React.Fragment>
          <Divider
            sx={{
              borderColor: '#EEEEEE',
              margin: 0,
              width: '100%',
            }}
          />

          <ScrollableOneClickFilterPanel
            displayFilters={displayFilters}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />
        </React.Fragment>
      )}

      <Divider
        sx={{
          borderColor: '#EEEEEE',
          marginBottom: '12px',
          width: '100%',
        }}
      />

      <Box
        sx={{
          overflowY: 'hidden',
          overflowX: 'auto',
          scrollbarWidth: 'none',
          display: 'flex',
          columnGap: '0.35rem',
          width: '100%',
          '& > *': { flex: '0 0 auto' },
        }}
      >
        <MealTypeFilter
          displayFilters={displayFilters}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
        <IngredientFilter
          displayFilters={displayFilters}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
        <PrimaryProteinFilter
          displayFilters={displayFilters}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
        <NutritionFactsFilter
          displayFilters={displayFilters}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
        <ShelfLifeFilter
          displayFilters={displayFilters}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
        <ChefFilter
          displayFilters={displayFilters}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
        <SourcingStandardFilter
          displayFilters={displayFilters}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
        {topRatedByUserCategory && topRatedByUserCategory.tags.length > 0 && (
          <TopRatedFilter
            topRatedByUserCategory={topRatedByUserCategory}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />
        )}
      </Box>

      <Divider
        sx={{
          borderColor: '#EEEEEE',
          marginTop: '12px',
          marginBottom: '12px',
          width: '100%',
        }}
      />
    </Grid>
  );
};

export default FilterPanel;
